import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Projectstock() {
  return (
    <section className="project_stock p-100 text_white bg_stock text_stock">
      <Container>
        <Row>
          <Col xs={12} md={4} lg={4} xl={4} xxl={4}>
            <h2>
              PROJECT <span>LOG</span>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h5>WHAT DID THE CLIENT PROVIDE?</h5>
            <p>
              The client had a general idea that resembled a management platform
              for businesses. With a rough blueprint for the digital product in
              mind, the insights provided were vital in determining what the
              next potential steps would look like.
            </p>
            <div className="log_marg_top">
              <h5>WHAT WERE THE RESULTS?</h5>
              <p>
                In the aftermath – Stock n Ship includes necessary measures for
                businesses to be rapid with their distribution and fulfillment
                processes. The API enables businesses to easily integrate their
                store into one of the portals at Stock n Ship.
              </p>
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} xl={2} xxl={2} className="text-center">
            <div className="line_img">
              <StaticImage
                src="../../../images/case-studies/stock/log_line.png"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={62}
                height={912}
              />
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h5>WHAT DID WE DO?</h5>
            <p>
              Our extensive research and development (R&D) plan included
              communicating our client's core needs and synergizing the idea
              with how businesses are evolving in this age.
            </p>
            <p>
              We covered how different platforms performed and developed Stock n
              Ship accordingly with a round of thorough quality assurance QA
              stages.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projectstock;
